import axios from "axios";


const axiosInstance = axios.create({
    baseURL: "https://api.cmtshr.top/api", // 替换为你的 API 基础 URL
    //baseURL: "/api/api",
    timeout: 60000,
    headers: { "Content-Type": "application/json" },
});

export default axiosInstance;
